module.exports = __webpack_public_path__ + "img/classiccar.ae129549.png";